import React from 'react';
import {
  TInfo,
  TStep3Branch,
  TStep3Info, //TStep6Info
} from '../../../types';
//import UploadInput from '../../global/UploadInput';
import FinalFormBusinessComponent from './FinalFormBusinessComponent';
import { getFromLocalStorage } from '../../../utils/setRegInfoInLocalStorage';

type TProps = {
  step1Info: TInfo;
  steP3Info: TStep3Info;
  setStep: React.Dispatch<React.SetStateAction<number>>;
};
const BusinessFinalForm = ({ steP3Info, step1Info, setStep }: TProps) => {
  // const branches_ = localStorage.getItem('branches');
  const branches_ = getFromLocalStorage('branches');
  const branches: TStep3Branch[] = branches_ && JSON.parse(branches_);

  return (
    <div>
      <div className='mb-[27px]'>
        <FinalFormBusinessComponent
          val={[
            {
              title: 'Business Segment',
              description: step1Info.businessSegment,
            },
            {
              title: 'Nature of business',
              description: step1Info.businessNature,
            },
          ]}
          setStep={setStep}
          step={1}
        />
        <hr className='mb-3' />
      </div>

      <div className='mb-[27px]'>
        <FinalFormBusinessComponent
          val={[
            {
              title: 'Business Objectives',
              description: step1Info.businessDesc,
            },
          ]}
          setStep={setStep}
          step={1}
        />
        <hr className='mb-3' />
      </div>

      <div>
        <FinalFormBusinessComponent
          val={[
            {
              title: 'Structure of Business',
              description: step1Info.structureOfBusiness,
            },
          ]}
          setStep={setStep}
          islocked
          step={1}
        />
        <hr className='mb-3' />
      </div>

      <div>
        <FinalFormBusinessComponent
          val={[
            {
              title: 'How many partners',
              description: step1Info.noOfPartners ?? '',
            },
          ]}
          setStep={setStep}
          islocked
          step={1}
        />
        <hr className='mb-3' />
      </div>

      <div>
        <FinalFormBusinessComponent
          val={[
            {
              title: 'Business name 1',
              description: step1Info.firstbusinessName,
            },
            {
              title: 'Business name 2',
              description: step1Info.secondbusinessName,
            },
            {
              title: 'Business name 3',
              description: step1Info.threebusinessName,
            },
          ]}
          setStep={setStep}
          step={2}
        />
        <hr className='mb-3' />
      </div>

      <div>
        <FinalFormBusinessComponent
          val={[
            {
              title: 'Business Address',
              description: steP3Info.streetNumber + ', ' + steP3Info.streetName,
            },
          ]}
          setStep={setStep}
          step={3}
        />
        <hr className='mb-3' />
      </div>

      {branches &&
        branches?.map((branch, index) => (
          // <>
          <div key={branch.streetNumber + branch.streetName}>
            <FinalFormBusinessComponent
              setStep={setStep}
              step={3}
              val={[
                {
                  title: 'Branch address' + ' ' + (index + 1).toString(),
                  description: branch.streetNumber + ', ' + branch.streetName,
                },
              ]}
            />
            <hr className='mb-3' />
            {/* <FinalFormBusinessComponent
              val={[
                {
                  title: {`asd`},
                  description: steP3Info.streetNumber + ', ' + steP3Info.streetName,
                },
              ]}
              setStep={setStep}
              step={3}
            />
            <hr  /> */}
          </div>
          // </>
        ))}
      <div>
        <FinalFormBusinessComponent
          val={[
            {
              title: 'Nearest Sterling bank branch',
              description: steP3Info.nearestSterlingBranch,
            },
          ]}
          setStep={setStep}
          step={3}
        />
      </div>
    </div>
  );
};

export default BusinessFinalForm;
